(() => {
  let cartAddFetchLocked = false;
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    try {
      const requestURL = typeof args[0] === 'string' ? args[0] : args[0]?.url;
      if (requestURL && requestURL.includes('/cart/add.js')) {
        if (cartAddFetchLocked) {
          console.warn('[pgn-cart-add-guard] Blocking duplicate call to /cart/add.js');
          return new Response(null, { status: 204 });
        }
        cartAddFetchLocked = true;
        console.log('[pgn-cart-add-guard] Allowing a single call to /cart/add.js');
        setTimeout(() => cartAddFetchLocked = false, 2000); // Desbloqueia após 2s
      }

      return originalFetch.apply(this, args);
    } catch (e) {
      console.error('[pgn-cart-add-guard] Error intercepting fetch:', e);
      return originalFetch.apply(this, args);
    }
  };
})();